export default "__VITE_ASSET__Z0BP7brn__"